// @flow
import type {Reducer} from '@travel-frontend/state-handling-sdk';
import type {V1State} from 'redux/v1/V1State';

import {combineReducers} from 'redux';

import {bookReducer} from 'redux/v1/book/reducer';
import {bookPsdFallbackReducer} from 'redux/v1/bookPsdFallback/reducer';
import {bookStatusReducer} from 'redux/v1/bookStatus/reducer';
import {customerReducer} from 'redux/v1/customer/reducer';
import {customerNoticeReducer} from 'redux/v1/customerNotice/reducer';
import {customerVouchersReducer} from 'redux/v1/customerVouchers/reducer';
import {formsheetReducer} from 'redux/v1/formsheet/reducer';
import {generatedVoucherReducer} from 'redux/v1/generatedVoucher/reducer';
import {imageReducer} from 'redux/v1/image/reducer';
import {insuranceReducer} from 'redux/v1/insurance/reducer';
import {journeyReducer} from 'redux/v1/journey/reducer';
import {organizerCancellationReducer} from 'redux/v1/organizerCancellation/reducer';
import {paymentInsuranceReducer} from 'redux/v1/paymentInsurance/reducer';
import {paymentTravelReducer} from 'redux/v1/paymentTravel/reducer';
import {priceCacheReducer} from 'redux/v1/priceCache/reducer';
import {psdMessageReducer} from 'redux/v1/psdMessage/reducer';
import {reservationReducer} from 'redux/v1/reservation/reducer';
import {serviceFeedbackReducer} from 'redux/v1/serviceFeedback/reducer';
import {touroperatorVoucherReducer} from 'redux/v1/touroperatorVoucher/reducer';
import {travelersReducer} from 'redux/v1/travelers/reducer';
import {voucherReducer} from 'redux/v1/voucher/reducer';
import {voucherDataReducer} from 'redux/v1/voucherData/reducer';

export const v1Reducer: Reducer<V1State> = combineReducers({
  journey: journeyReducer,
  organizerCancellation: organizerCancellationReducer,
  travelers: travelersReducer,
  reservation: reservationReducer,
  customer: customerReducer,
  customerNotice: customerNoticeReducer,
  formsheet: formsheetReducer,
  insurance: insuranceReducer,
  paymentTravel: paymentTravelReducer,
  paymentInsurance: paymentInsuranceReducer,
  book: bookReducer,
  bookStatus: bookStatusReducer,
  bookPsdFallback: bookPsdFallbackReducer,
  psdMessage: psdMessageReducer,
  voucher: voucherReducer,
  voucherData: voucherDataReducer,
  generatedVoucher: generatedVoucherReducer,
  touroperatorVoucher: touroperatorVoucherReducer,
  serviceFeedback: serviceFeedbackReducer,
  images: imageReducer,
  priceCache: priceCacheReducer,
  customerVouchers: customerVouchersReducer,
});
